import React from 'react'
import {dataUtils} from "../../js/dataUtils";
// import {useIntl} from "react-intl";
import {applyooConfig} from "../../js/applyooConfig";
import UI_ApplyooIcon from "./UI_ApplyooIcon";

type avatarSize = 'xs' | 'sm' | 'md' //| 'lg' | 'xl'
type avatarColor = 'primary' | 'secondary' | 'success' | 'info' | 'danger'

interface Props {
    title?: string,
    ImageUrl?: string,
    color?: avatarColor,
    size?: avatarSize,
    initials?: boolean,
    // UserID?: boolean,
    // onClickCallbackFunction?: any,
}
const UI_ApplyooAvatar = (props: Props & {className?: string}) => {
    let avatarText = ""
    let avatarColor = "" //props.style
    let avatarSize = props.size
    let sizeClassName = 'img-sm-wrapper'

    switch (avatarSize) {
        case 'xs':
            sizeClassName = 'img-xs-wrapper image-in-drop-down-listXXX size-sqr-24'
            break;

        case 'sm':
            sizeClassName = 'img-sm-wrapper size-sqr-32 font-medium-1'
            break;

        case 'md':
            sizeClassName = 'img-md-wrapper'
            break;

        default:
            sizeClassName = 'img-xs-wrapper size-sqr-24'
            //sizeClassName = 'size-sqr-32 font-medium-1'
            break;
    }

    const dicColors = {
        0: 'bg-gradient-success',
        1: 'bg-gradient-info',
        2: 'bg-gradient-primary',
        3: 'bg-gradient-secondary',
        4: 'bg-gradient-danger',
    }

    const setAutoColorByInitials = () => {
        let initialsValue = 0;

        for (let ind01 = 0; ind01 < avatarText.length ; ind01++) {
            let charCode = avatarText.charCodeAt(ind01);

            initialsValue += charCode;
        }

        const modVal = initialsValue % 5
        // @ts-ignore
        avatarColor = dicColors[modVal]
    }

    const getInitialsByText = () => {
        let outVal = "";

        if(!!props?.title){
            let arrText = props?.title?.toString()?.split(" ")

            if (!!arrText && arrText.length == 1){
                outVal = arrText[0].substring(0,1)
            }

            else if (!!arrText && arrText.length >= 2){
                outVal = arrText[0].substring(0,1) + arrText[1].substring(0,1)
            }

        }

        return outVal
    }

    if (!!props?.initials || !props?.ImageUrl){
        avatarText = getInitialsByText()

        if (!props.color){
            setAutoColorByInitials()
        }
        else {
            avatarColor = `bg-gradient-${props.color}`
        }

        if (!avatarSize){
            avatarSize = "md"
        }
    }

    // const onAvatarClicked = (prmEvent:any) => {
    //     if (!!props.onClickCallbackFunction && !!props.UserID) {
    //         prmEvent.stopPropagation();
    //         props.onClickCallbackFunction(props.UserID)
    //         // taskeemNS.showUserInfo(props.UserID)
    //     }
    // }

  return (
      // onClick={(prmEvent:any) => onAvatarClicked(prmEvent)}
      <div className={["avatar ",`avatar-${avatarSize}`].join(" ")} >
          {
              !props?.ImageUrl && !props.title ?
                  (<UI_ApplyooIcon iconStr='user' className={["avatar-content",sizeClassName, props.className].join(" ")} />)
              :
              !props?.ImageUrl || !!props.initials ? (
                    <span className={["avatar-content",avatarColor,props.className,sizeClassName].join(" ")}
                          title={props.title}>
                        {avatarText}
                    </span>
                    )
                    :
                    (<img className={[props.className, "rounded-circle", sizeClassName].join(" ")}
                        src={`${applyooConfig.baseFilesURL}${props.ImageUrl}`}
                        title={props.title} />)
          }

      </div>
      )
}

export default UI_ApplyooAvatar